import { useQuery } from '@tanstack/react-query';

import { Template } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useTemplate = (id, type) =>
  useQuery({
    queryKey: ['template', id],
    queryFn: async (): Promise<Template> => {
      try {
        if (!id) {
          return {
            name: 'New template',
            mappingFields: [],
            declarants: [],
            transactionType: '',
            additionalFixedValues: [],
            type,
            deleted: false,
          };
        }
        const { data } = await request({
          path: `template/${id}`,
          method: 'GET',
          authenticate: true,
        });
        return data.template;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch template details');
      }
    },
  });
